import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

@Component({
    selector: "clare-signal-strength",
    templateUrl: "./clare-signal-strength.component.html",
    styleUrls: ["./clare-signal-strength.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClareSignalStrengthComponent {
    @Input() signalStrength: number;

    highlightBar(bar: number) {
        return { colored: this.signalStrength / 20 > bar };
    }
}
